import React from 'react';
import { WarningCircle, ArrowClockwise } from '@phosphor-icons/react';
import { getBackendUrl } from '../../config/urlAuthority';

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("!!! SILENCE KILL SWITCH CAUGHT ERROR !!!", error, errorInfo);
        try {
            let apiBase = '';
            try { apiBase = getBackendUrl().replace(/\/$/, ''); } catch (_) {}
            fetch(`${apiBase}/api/system/dev-event`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_type: 'frontend_runtime',
                    taxonomy_code: 'FRONTEND_RUNTIME_EXCEPTION',
                    domain: 'ui',
                    layer: 2,
                    severity: 'blocker',
                    file_path: errorInfo?.componentStack?.split('\n')[1]?.trim() || 'unknown',
                    commit_hash: window.__BUILD_HASH__ || '',
                    session_id: `fe-${Date.now()}`,
                    resolved: false,
                    violation_description: error?.toString() || 'Unknown frontend error',
                }),
            }).catch(() => {});
        } catch (_) {}
        this.setState({ error: error, errorInfo: errorInfo });
    }

    handleRetry = () => {
        this.setState({ hasError: false });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ background: '#f00', color: '#fff', padding: '20px', position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 999999, overflow: 'auto', maxHeight: '100vh', fontFamily: 'monospace' }} /* noscan — emergency kill-switch overlay, intentional high-visibility red */>
                    <h1 style={{ margin: 0 }}>🚨 SYSTEM FAILURE DETECTED (SILENCE KILL SWITCH ACTIVE)</h1>
                    <pre style={{ background: '#300', padding: '10px', marginTop: '10px' }} /* noscan — emergency kill-switch overlay */>
                        {this.state.error && this.state.error.toString()}
                    </pre>
                    <pre style={{ background: '#300', padding: '10px', marginTop: '10px', fontSize: '10px' }} /* noscan — emergency kill-switch overlay */>
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </pre>
                    <button onClick={() => window.location.reload()} style={{ background: '#fff', color: '#000', padding: '10px', border: 'none', cursor: 'pointer', marginTop: '10px' }} /* noscan — emergency kill-switch overlay */>RELOAD SYSTEM</button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default AppErrorBoundary;
